module.exports = __webpack_public_path__ + "static/media/frcrce_logo.f75a53ef.jpg";